import React from "react";
import { Button } from "react-materialize";

export default function MyProfileRightBtnSave({ data, isSaving, handleEvents }) {
  return (
    <Button
      className=""
      id="btn-save"
      node="button"
      waves="light"
      disabled={Boolean(isSaving)}
      onClick={handleEvents}
      // onClick={() =>
      //   (window.location.href = `/employees/profile/?tab=employeeinfo&id=${data.idu}`)
      // }
      style={{
        borderRadius: "8px",
        display: "inline-block",
        margin: "0 auto",
      }}
    >
      {isSaving ? "Saving..." : "Save"}
    </Button>
  );
}
